import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const AddEditQCRuleGroupModal = React.lazy(
  () => import("./add-edit-qc-rule-group.modal"),
);

const AddEditQCRuleGroup: iModalProps<
  typeof AddEditQCRuleGroupModal,
  {
    ruleGroupId?: string;
    onSaved?: () => void;
  }
> = {
  name: "add-edit-qc-rule-group",
  component: GenerateModalWithSuspense(AddEditQCRuleGroupModal),
};

export default AddEditQCRuleGroup;
